import React from 'react';
import ErrorPage from './ErrorPage';

const ForbiddenPage = () => (
  <ErrorPage
    code="403"
    tone="danger"
    eyebrow="Forbidden"
    title="This area is admin-only."
    message="The wallet you're signed in with doesn't have admin rights for Phonestream. If you believe this is wrong, double-check the connected wallet or contact the team."
    primaryCta={{ label: 'Go to my dashboard', to: '/dashboard' }}
    secondaryCta={{ label: 'Back to home', to: '/' }}
  />
);

export default ForbiddenPage;
